import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import RichTextEditor from "react-rte";
import "../termsAndConditions/termsAndConditions.css";
import { toast } from "react-toastify";

const PrivacyPolicy = ({ onChange }) => {
  const [value, setValue] = useState(
    RichTextEditor.createValueFromString(``, "html")
  );

  const handleChange = (value) => {
    setValue(value);
    if (onChange) {
      // Send the changes up to the parent component as an HTML string.
      // This is here to demonstrate using `.toString()` but in a real app it
      // would be better to avoid generating a string on each change.
      onChange(value.toString("html"));
    }
  };

  const createPrivacyPolicy = async () => {
    try {
      const data = {
        content: value.toString("html"),
        type: "privacyAndPolicy",
      };

      const response = null;

      if (response) {
        toast.success("Update successfully !");
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const loadContents = async () => {
    try {
      const response = null;

      const initialValue = RichTextEditor.createValueFromString(
        `${response.privacyAndPolicy} `,
        "html"
      );

      setValue(initialValue);
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    loadContents();
  }, []);

  return (
    <div className="container">
      <div className="overview d-flex align-items-center justify-content-between">
        <div className="title">
          <ion-icon name="lock-closed-outline"></ion-icon>
          <span className="text">Privacy Policy</span>
        </div>
        <button
          id="privacy-and-policy"
          className="btn-header d-flex align-items-center gap-1"
          onClick={createPrivacyPolicy}
        >
          {/* <ion-icon name="add-outline"></ion-icon> */}
          Update
        </button>
      </div>
      <div>
        <RichTextEditor
          value={value}
          onChange={handleChange}
          className="terms-conditions"
        />
      </div>
    </div>
  );
};

// PrivacyPolicy.propTypes = {
//   onChange: PropTypes.func,
// };

export default PrivacyPolicy;
